/**
 * Pixel Constants
 * Stores information related to Social Media Pixels.
 */
export const PixelConstants = Object.freeze({
    ONLY_PRODUCTION_MODE: true,
    META: {
        ID: `${process.env.REACT_APP_META_PIXEL_ID}`
    },
    GOOLGE: {
        ANALYTICS_MEASUREMENT_ID: `${process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID}`
    },
    EVENTS: {
        UPLOAD_PHOTO_CHOSEN: 'upload_photo_file_chosen',
        UPLOAD_PHOTO_CONTINUE_CLICK: 'upload_photo_continue_click',
        UPLOAD_PHOTO_SIGNUP_EMAIL_CLICK: 'upload_photo_signup_email_click',
        UPLOAD_PHOTO_CONTINUE_GOOGLE_CLICK: 'upload_photo_continue_google_click',
        UPLOAD_PHOTO_LOGIN_CLICK: 'upload_photo_login_click',
        ADD_ITEMS_IMAGE_DOWNLOAD: 'add_items_image_download',
        ADD_ITEMS_CONTINUE_CLICK: 'add_items_continue_click',
        ADD_ITEMS_TOTAL_ESTIMATION: 'add_items_total_estimation',
        ADD_ITEMS_ZIP_CODE_SET: 'add_items_zip_code_set',
        PROJECT_CREATE_CLICK: 'project_create_click'
    }
})